import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { DataService } from "src/app/bpg-common/services/data.services";
import { ActivatedRoute } from "@angular/router";
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';
import { Router } from '@angular/router';
import { SelfService } from 'src/app/bpg-self-services/self-services.service.ts';
import { LandingPaginationDTO } from "src/app/bpg-common/services/data.services";
import { ConstantValues } from "src/app/bpg-common/models/bpg-constants";
import { DatePipe } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-naac-home-page',
  templateUrl: './naac-home-page.component.html',
  styleUrls: ['./naac-home-page.component.css']
})

export class NaacHomePageComponent implements OnInit {
  adminId: any;
  selectedNaacId: any;
  selectedNaacName: any;
  LandingPaginationDTO: LandingPaginationDTO = new LandingPaginationDTO();

  naacDetailsList: any = [];
  imageURL: string = '';
  visionStatement: string = '';
  affinityGoal: string = '';
  naacLogo : string = ''
  naacNewsList: any = [];
  selectedNewsList: any = [];

  Maxmin: string = '+';
  naacFolderList: any = [];
  selectedFolder: any = [];
  naacResourceList: any = [];
  selectedResourceList: any = [];
  fileList: any = [];
  flag2: boolean = false;

  naacReTeamList: any = [];
  selectedReTeamList: any = [];

  //map section
  mapDetailsList: any = [];
  totalMembershipCount: any;
  totalSites: any;
  totalChapters: any;
  bpgId: number;
  siteDetails: any = [];

  eventList: any = [];

  //summary section
  selectedSite: any = 0;
  siteListforBpg: any = [];
  naacAffinityId: any;
  minDate: any;
  maxDate: any;
  currentYearDisplay: any;
  nextYearDisplay: number;
  checkYear: string = 'currentFiscalYear';
  calculateYear: string = 'currentFiscalYear';
  summaryDetails: any = [];
  hoshinStatus: string;
  fiscalYear: any;
  chapterEmail: any;
  isNaacAdmin : boolean = false;

  // events section
  event_details: string;
  event_name: any;
  event_id: string;
  hideArrow: boolean = false;
  naac_name: any;
  eventName: string;
  eventDetails = [];
  iconKeyList: any;
  upcoming_events_info: any = [];

  @ViewChild("areaMapUSA", { static: true }) areaMapUSA: ElementRef;
  @ViewChild("areaMapCanada", { static: true }) areaMapCanada: ElementRef;
  @ViewChild("areaMapMexico", { static: true }) areaMapMexico: ElementRef;

  /**
   * @class BpgChapterHomePageComponent
   * @constructor
   */
  constructor(private route: ActivatedRoute,
    private data: DataService,
    private router: Router,
    private spinnerService: Ng4LoadingSpinnerService,
    
    private environment: EnvironmentConfiguration,
    private naacService: SelfService,
    private datePipe: DatePipe,
    private sanitizer : DomSanitizer

  ) {

  }

  ngOnInit() {
    this.spinnerService.show();
    if (this.environment.envName == 'dev' || this.environment.envName == 'qa' || this.environment.envName == 'prod') {
              if (localStorage.getItem('loginData')== null || localStorage.getItem('loginData')== undefined) {

        this.router.navigate(['/log-out']);
      }
    }
    // let responseData = [];

    this.data.selectedNaacIdForNaacMenu.subscribe(myData => {
      this.selectedNaacId = localStorage.getItem("selectedNaacId");
      this.selectedNaacName = localStorage.getItem("selectedNaacName");
      this.naacAffinityId = localStorage.getItem("naacAffinityId");
      this.adminId = localStorage.getItem('adminId');
      this.currentYearDisplay = new Date().getFullYear().toString().slice(2, 4);
      this.nextYearDisplay = parseInt(this.currentYearDisplay) + 1;
      if (new Date().getMonth() >= 3) {
        this.currentYearDisplay = this.nextYearDisplay;
        this.nextYearDisplay += 1;
      }
      if(localStorage.getItem('isNaacAdmin') == 'true')
      {
        this.isNaacAdmin = true;
      }
      this.spinnerService.hide();
      this.getnaacBannerList();
      this.getnaacFolderList();
      this.getNaacResouceList();
      this.getnaacnewsList();
      this.getnaacREteam();
      this.getMapDetails();
      this.getnaacSites();
      this.getnaacSummary('currentFiscalYear');
      this.getEventDetails();
      this.selectedSite = 0;
    }
    )
  }

  /** get naac site list
* @class NaacComponent
* @method getnaacSites
*/
  getnaacSites() {

    this.LandingPaginationDTO = {
      "filter": { "naacAffinityId": this.naacAffinityId },
      "moduleId": 0,
      "page": 0,
      "presentRole": "string",
      "searchTerm": "string",
      "size": 0,
      "sortDirection": "ASC",
      "sortProperty": "string",
      "uid": "string"
    }
    this.naacService.getsiteDetails(this.LandingPaginationDTO).subscribe(data => {
      this.siteListforBpg = data;
      if (this.siteListforBpg.length > 0) {
        this.siteListforBpg.unshift({ siteId: 0, siteName: 'All Chapters' });
      }
    })
  }


  /** get naac summary details
* @class NaacComponent
* @method getnaacSummary
*/
  getnaacSummary(value) {

    this.calculateYear = value
    var today = new Date();
    var month = today.getMonth();
    var year = today.getFullYear();
    if (this.calculateYear == 'currentFiscalYear') {
      if (month < 3) {
        this.minDate = new Date(year - 1 + "/04/01");
        this.maxDate = new Date(year + "/03/31");
        this.fiscalYear = new Date().getFullYear();
      }
      else if (month >= 3) {
        this.minDate = new Date(year + "/04/01");
        this.maxDate = new Date(year + 1 + "/03/31");
        this.fiscalYear = new Date().getFullYear() + 1;
      }
    }
    else if (this.calculateYear == 'nextFiscalYear') {
      if (month >= 3) {
        this.minDate = new Date(year + 1 + "/04/01");
        this.maxDate = new Date(year + 2 + "/03/31");
        this.fiscalYear = new Date().getFullYear() + 2;
      }
      else if (month < 3) {
        this.minDate = new Date(year + "/04/01");
        this.maxDate = new Date(year + 1 + "/03/31");
        this.fiscalYear = new Date().getFullYear() + 1;
      }
    }
    var summaryData;
    if (this.selectedSite != null || this.selectedSite != undefined) {
      summaryData = {
        siteId: this.selectedSite,
        naacAffinityId: this.naacAffinityId,
        fromDate: this.minDate,
        toDate: this.maxDate,
        fiscalYear: this.fiscalYear
      }
    }
    else {
      summaryData = {
        siteId: 0,
        naacAffinityId: this.naacAffinityId,
        fromDate: this.minDate,
        toDate: this.maxDate,
        fiscalYear: this.fiscalYear
      }
    }

    this.naacService.getSummaryDetails(summaryData).subscribe(data => {
      this.summaryDetails = data;
      this.hoshinStatus = this.summaryDetails.budgetHoshinStatus;
      this.selectedSite = this.summaryDetails.siteId;
      this.chapterEmail = this.summaryDetails.chapterEmail;
      this.summaryDetails.totalExpense = this.summaryDetails.totalExpense == null ? 0 : this.summaryDetails.totalExpense;
      if (this.hoshinStatus == 'SUBMITTED' || this.hoshinStatus == 'APPROVED'
        || this.hoshinStatus == 'DRAFT' || this.hoshinStatus == 'REJECTED') {
        this.summaryDetails.noHoshin = false;
      }
      else
        this.summaryDetails.noHoshin = true;

    })

  }

  /** open outlook to send email to chapter Admins
* @class NaacComponent
* @method contactUs
*/
  contactUs() {
    window.location.assign("mailto:" + this.chapterEmail);
  }

  /** get list of sites for map
* @class NaacComponent
* @method getMapDetails
*/
  getMapDetails() {
    this.spinnerService.show();
    var mapData = {
      "filter": { "naacId": this.selectedNaacId },
      "moduleId": 0,
      "page": 0,
      "presentRole": "string",
      "searchTerm": "string",
      "size": 0,
      "sortDirection": "ASC",
      "sortProperty": "string",
      "uid": "string"
    }
    this.naacService.getMapDataforNaac(mapData).subscribe(data => {
      this.mapDetailsList = data;
      if (this.mapDetailsList != null && this.mapDetailsList != undefined) {
        var mapArrayUSA = [];
        var mapArrayCanada = [];
        var mapArrayMexico = [];
        this.totalMembershipCount = this.mapDetailsList.totalMembershipCount;
        this.totalSites = this.mapDetailsList.totalSites;
        this.totalChapters = this.mapDetailsList.totalChapters;
        for (var j = 0; j < this.mapDetailsList.siteMasterDTO.length; j++) {

          if (this.mapDetailsList.siteMasterDTO[j].countryName == "USA")
            mapArrayUSA.push({ "z": this.mapDetailsList.siteMasterDTO[j].membershipCount, "membershipCount": this.mapDetailsList.siteMasterDTO[j].membershipCount, "parentState": this.mapDetailsList.siteMasterDTO[j].siteName, "lat": this.mapDetailsList.siteMasterDTO[j].siteLatitude, "lon": this.mapDetailsList.siteMasterDTO[j].siteLongitude });
          if (this.mapDetailsList.siteMasterDTO[j].countryName == "Canada")
            mapArrayCanada.push({ "z": this.mapDetailsList.siteMasterDTO[j].membershipCount, "membershipCount": this.mapDetailsList.siteMasterDTO[j].membershipCount, "parentState": this.mapDetailsList.siteMasterDTO[j].siteName, "lat": this.mapDetailsList.siteMasterDTO[j].siteLatitude, "lon": this.mapDetailsList.siteMasterDTO[j].siteLongitude });
          if (this.mapDetailsList.siteMasterDTO[j].countryName == "Mexico")
            mapArrayMexico.push({ "z": this.mapDetailsList.siteMasterDTO[j].membershipCount, "membershipCount": this.mapDetailsList.siteMasterDTO[j].membershipCount, "parentState": this.mapDetailsList.siteMasterDTO[j].siteName, "lat": this.mapDetailsList.siteMasterDTO[j].siteLatitude, "lon": this.mapDetailsList.siteMasterDTO[j].siteLongitude });
        }

        {
          let HighchartsUSA = require('highcharts/highmaps.js'),
            USAmap = require('@highcharts/map-collection/countries/us/custom/us-all-mainland.geo.json');
          HighchartsUSA.mapChart(this.areaMapUSA.nativeElement, {
            chart: {
              type: 'map',
              height: 370,
              width: 370,
              backgroundColor: 'lightgray'
            },
            title: {
              useHTML: true,
              text: "<img src='/assets/images/usaflag.png'    height='19px' width='32px'/>  USA",
              verticalAlign: 'bottom',
              style: {
                fontFamily: 'Montserrat-light',
                fontWeight: 'bold',
                marginLeft: '8px',
                color: 'black',
              },
            },

            tooltip: {
              formatter: function () {
                return '<b>' + this.point.parentState + '</b><br/>' +
                  "Membership Count: <b>" + this.point.membershipCount + "</b>";
              }
            },
            credits: {
              enabled: false
            },
            legend: {
              enabled: false
            },

            series: [{
              name: 'Basemap',
              mapData: USAmap,
              borderColor: '#f1a691 ',
              nullColor: 'white',
              showInLegend: false
            }, {
              type: 'mapbubble',
              data: mapArrayUSA,
              maxSize: '5%',
              color: '#b62027 '
            }]

          }
          );
        }
        //canada select all
        {
          let HighchartsCanada = require('highcharts/highmaps.js'),
            Canadamap = require('@highcharts/map-collection/countries/ca/ca-all.geo.json');
          HighchartsCanada.mapChart(this.areaMapCanada.nativeElement, {
            chart: {
              type: 'map',
              height: 370,
              width: 370,
              backgroundColor: 'lightgray'
            },
            title: {
              useHTML: true,
              text: "<img src='/assets/images/canadaflag.png'    height='19px' width='32px' />  CANADA",
              verticalAlign: 'bottom',
              style: {
                fontFamily: 'Montserrat-light',
                fontWeight: 'bold',
                marginLeft: '8px',
                color: 'black',
              },
            },
            tooltip: {
              formatter: function () {
                return '<b>' + this.point.parentState + '</b><br/>' +
                  "Membership Count: <b>" + this.point.membershipCount + "</b>";
              }
            },
            credits: {
              enabled: false
            },
            legend: {
              enabled: false
            },
            series: [{
              name: 'Basemap',
              mapData: Canadamap,
              borderColor: '#f1a691 ',
              nullColor: 'white',
              showInLegend: false
            }, {
              type: 'mapbubble',

              data: mapArrayCanada,
              maxSize: '5%',
              color: '#b62027 '
            }]
          });
        }
        {
          let HighchartsMexico = require('highcharts/highmaps.js'),
            Mexicomap = require('@highcharts/map-collection/countries/mx/mx-all.geo.json');
          HighchartsMexico.mapChart(this.areaMapMexico.nativeElement, {
            chart: {
              type: 'map',
              height: 370,
              width: 370,
              backgroundColor: 'lightgray'
            },

            title: {
              useHTML: true,
              text: "<img src='/assets/images/mexicoflag.png'   height='19px' width='32px' />  MEXICO",
              verticalAlign: 'bottom',
              style: {
                fontFamily: 'Montserrat-light',
                fontWeight: 'bold',
                marginLeft: '8px',
                color: 'black',
              },
            },
            tooltip: {
              formatter: function () {
                return '<b>' + this.point.parentState + '</b><br/>' +
                  "Membership Count: <b>" + this.point.membershipCount + "</b>";
              }
            },
            credits: {
              enabled: false
            },
            legend: {
              enabled: false
            },

            series: [{
              name: 'Basemap',
              mapData: Mexicomap,
              borderColor: '#f1a691 ',
              nullColor: 'white',
              showInLegend: false
            }, {
              type: 'mapbubble',
              data: mapArrayMexico,
              maxSize: '5%',
              color: '#b62027 '
            }]
          });

        }

      }
    }
    )
    this.spinnerService.hide();
  }


  /** get banner image list
   * @class BannerImage
   * @method getdiBannerList
   */
  getnaacBannerList() {
    this.spinnerService.show();
    this.LandingPaginationDTO = {
      "filter": { "naacFlag": "naacSelfService" },
      "moduleId": 0,
      "page": 0,
      "presentRole": "",
      "searchTerm": "",
      "size": 50,
      "sortDirection": "ASC",
      "sortProperty": "naacId",
      "uid": "",
    }
    this.naacService.getnaacBannerList(this.LandingPaginationDTO).subscribe(data => {
      this.naacDetailsList = data.content;
      if (this.naacDetailsList != null && this.naacDetailsList != undefined) {
        this.spinnerService.hide();
        this.imageURL = '';
        this.visionStatement = '';
        this.affinityGoal = '';
        for (var i = 0; i < this.naacDetailsList.length; i++) {
          if (this.selectedNaacId == this.naacDetailsList[i].naacId) {
            this.imageURL = this.naacDetailsList[i].naacName;
            this.visionStatement = this.naacDetailsList[i].naacVision;
            this.affinityGoal = this.naacDetailsList[i].naacAffinity;
            this.naacLogo = this.naacDetailsList[i].naacLogoUrl;
            break
          }
        }
      }
    })

  }

  /** get list of naac news
* @class NaacComponent
* @method getnaacnewsList
*/
  getnaacnewsList() {
    this.spinnerService.show();
    this.LandingPaginationDTO.size = ConstantValues.pageLimit;
    this.LandingPaginationDTO = {
      "filter": { "naacFlag": "naacSelfService" },
      "moduleId": 0,
      "page": 0,
      "presentRole": "",
      "searchTerm": "",
      "size": 500,
      "sortDirection": "ASC",
      "sortProperty": "modifiedDateTime",
      "uid": ""
    }

    this.naacService.getnaacnewsList(this.LandingPaginationDTO).subscribe(data => {
      this.naacNewsList = data.content;
      if (this.naacNewsList != null && this.naacNewsList != undefined) {
        this.spinnerService.hide();
        this.selectedNewsList = [];
        for (var i = 0; i < this.naacNewsList.length; i++) {
          if (this.selectedNaacId == this.naacNewsList[i].naacId) {
            this.selectedNewsList.push(this.naacNewsList[i])
          }
        }

        for (var i = 0; i < this.selectedNewsList.length; i++) {
          this.selectedNewsList[i].wordCount = 0;
          if (this.selectedNewsList[i].naacImageCheck == false) {
            this.selectedNewsList[i].naacNewsUrl = '/assets/images/news_logo.jpg';
          }
        }
        for (var j = 0; j < this.selectedNewsList.length; j++) {
          if (this.selectedNewsList[j].naacNewsDesc != null && this.selectedNewsList[j].naacNewsDesc != '' && this.selectedNewsList[j].naacNewsDesc != undefined) {
            this.selectedNewsList[j].wordCount = this.selectedNewsList[j].naacNewsDesc.split(" ").length;
            if (this.selectedNewsList[j].wordCount >= 30) {
              this.selectedNewsList[j].minWord = this.selectedNewsList[j].naacNewsDesc.slice(0, 160);
              this.selectedNewsList[j].minWord = this.selectedNewsList[j].minWord + '...';
              this.selectedNewsList[j].showFullWord = false;
            }
            else
              this.selectedNewsList[j].showFullWord = true;

          }
          else {
            this.selectedNewsList[j].showFullWord = true;
          }
        }
        var element = document.getElementById('newsId');
        if(this.selectedNewsList.length==2){
          element.className='news-scroll';
          element.style["animationDuration"]=this.selectedNewsList.length * 6 + "s";
        }
       else if(this.selectedNewsList.length>2){
        element.className='news-scroll';
        element.style["animationDuration"]=this.selectedNewsList.length * 3.5 + "s";
       }else{
          element.className="none";
        }
      }
    })
  }
  /** For download files of the resources
     * @class NaacHomePage Component
     * @method downloadAttachments
     */
  downloadAttachments(urls, i) {
    console.log(urls, i);
    var extension = urls.substring(urls.lastIndexOf('.') + 1);
    var link = document.getElementById('downloadFiles' + i);
    link.setAttribute('href', urls);
    link.setAttribute('download', urls);
    if (extension.includes('mp4')) {
      link.setAttribute('target', '_blank');
    }
    if (extension == 'pdf' || 'csv') {
      link.setAttribute('target', '_blank');
    }
  }
  /** get Folder list
    * @class AdditionalResourceComponent
    * @method getnaacFolderList
    */
  public getnaacFolderList() {
    let landingData = {
      "filter": {},
      "moduleId": 0,
      "page": 0,
      "presentRole": "",
      "searchTerm": "",
      "size": 50,
      "sortDirection": "ASC",
      "sortProperty": "folder_order",
      "uid": ""
    }

    this.naacService.getNaacDocumentsFolder(landingData).subscribe(data => {
      this.naacFolderList = data.content;
      this.selectedFolder = [];
      for (var i = 0; i < this.naacFolderList.length; i++) {
        if (this.selectedNaacId == this.naacFolderList[i].naacId) {

          this.selectedFolder.push(this.naacFolderList[i]);

        }
      }

      for (let j = 0; j < this.selectedFolder.length; j++) {
        this.selectedFolder[j].Maxmin = '+';
      }
    });
  }

  /** For displaying files based on folder selection
     * @class EventViewDetailsComponent
     * @method selectnaacFolder
     */
  selectnaacFolder(folderid) {
    this.fileList = [];

    for (var j = 0; j < this.selectedResourceList.length; j++) {
      if (this.selectedResourceList[j].folderId == folderid) {
        this.fileList.push(this.selectedResourceList[j]);
      }
    }

    for (var i = 0; i < this.selectedFolder.length; i++) {
      if (this.selectedFolder[i].folderId == folderid) {
        if (this.selectedFolder[i].showFolder == false || this.selectedFolder[i].showFolder == undefined || this.selectedFolder[i].showFolder == null) {
          this.selectedFolder[i].Maxmin = '-';
          this.selectedFolder[i].showFolder = true;
        }
        else {
          this.selectedFolder[i].Maxmin = '+';
          this.selectedFolder[i].showFolder = false;
        }
      }
      else {
        this.selectedFolder[i].Maxmin = '+';
        this.selectedFolder[i].showFolder = false;
      }
    }
  }


  /** get list of naac resource
   * @class NaacComponent
   * @method getNaacResouceList
   */
  getNaacResouceList() {
    this.spinnerService.show()
    this.LandingPaginationDTO.size = ConstantValues.pageLimit;
    this.LandingPaginationDTO = {
      "filter": { "naacFlag": "naacHomePage" },
      "moduleId": 0,
      "page": 0,
      "presentRole": "",
      "searchTerm": "",
      "size": 500,
      "sortDirection": "ASC",
      "sortProperty": "folderOrder",
      "uid": ""
    }

    this.naacService.getnaacResource(this.LandingPaginationDTO).subscribe(data => {
      this.naacResourceList = data.content;
      {
        if (this.naacResourceList != null && this.naacResourceList != undefined)
          this.spinnerService.hide();
        this.selectedResourceList = [];
        for (var z = 0; z < this.naacResourceList.length; z++) {
          if (this.selectedNaacId == this.naacResourceList[z].naacId) {
            this.selectedResourceList.push(this.naacResourceList[z])
          }
        }
      }
    }
    )
  }
  /** get list of naac Reteam
   * @class NaacComponent
   * @method getnaacREteamList
   */
  getnaacREteam() {
    this.spinnerService.show();
    this.LandingPaginationDTO.size = ConstantValues.pageLimit;
    this.LandingPaginationDTO = {
      "filter": { "naacFlag": "naacHomePage" },
      "moduleId": 0,
      "page": 0,
      "presentRole": "",
      "searchTerm": "",
      "size": 500,
      "sortDirection": "ASC",
      "sortProperty": "regionalOrder",
      "uid": ""
    }
    this.naacService.getnaacREteam(this.LandingPaginationDTO).subscribe(data => {
      this.naacReTeamList = data.content;
      if (this.naacReTeamList != null && this.naacReTeamList != undefined)
        this.spinnerService.hide();
      this.selectedReTeamList = [];
      for (var a = 0; a < this.naacReTeamList.length; a++) {
        if (this.selectedNaacId == this.naacReTeamList[a].naacId) {
          this.selectedReTeamList.push(this.naacReTeamList[a])
        }
      }
    }
    )
  }



  /** For displaying full description
       * @class NaacComponent
       * @method showFullDesc
       */
  showFullDesc(newsid) {
    for (var i = 0; i < this.selectedNewsList.length; i++) {
      if (this.selectedNewsList[i].naacNewsId == newsid) {
        this.selectedNewsList[i].showFullWord = true;
      }
    }
  }

  /** For adding 365 days to current day
     * @class NaacHomePageComponent
     * @method addDays
     * @params Date, number
     */
  addDays(date: Date, days: number): Date {
    date.setDate(date.getDate() + days);
    return date;
  }
  //Event details
  getEventDetails() {
    this.spinnerService.show();
    this.LandingPaginationDTO.size = ConstantValues.pageLimit;
    let fromDate = this.datePipe.transform(new Date, ConstantValues.dateFormats.dateFormat);
    let toDate = this.datePipe.transform(this.addDays(new Date, 365), ConstantValues.dateFormats.dateFormat);


    this.LandingPaginationDTO = {
      "filter": {
        "naacAffinityId": this.naacAffinityId,
        "siteId": 0,
        "fromDate": fromDate,
        "toDate": toDate
      },
      "moduleId": 0,
      "page": 0,
      "presentRole": "",
      "searchTerm": "",
      "size": 3,
      "sortDirection": "ASC",
      "sortProperty": "event_create_date",
      "uid": ""
    }

    this.naacService.getNaacEvents(this.LandingPaginationDTO).subscribe(data => {
      this.upcoming_events_info = (data.content) ? data.content : '';
      if (this.upcoming_events_info.length > 0) {
        this.event_details = this.upcoming_events_info[0].description;
        this.eventName = this.upcoming_events_info[0].eventName;
        this.event_id = this.upcoming_events_info[0].eventId;
      } else {
        this.event_details = '';
        this.eventName = 'No upcoming events available';
        this.event_id = '';
      }


    })

  }


  /** For displaying the events name and description on clicking of events
 * @class BpgSiteHomePageComponent
 * @method openeventsDetails
 * @param event_id
 */
  openeventsDetails(event_id) {

    document.getElementById("event_description_div").scrollIntoView({ behavior: "smooth", block: "center" });
    for (var i = 0; i < this.upcoming_events_info.length; i++) {
      if (event_id == this.upcoming_events_info[i].eventId) {

        this.event_id = event_id;
        document.getElementById("eventlist" + i + "" + i).classList.add("hideArrow");
        this.eventName = this.upcoming_events_info[i].eventName;
        this.event_details = this.upcoming_events_info[i].description;
      }
      if (event_id != this.upcoming_events_info[i].eventId) {
        if (i == 0) {
          document.getElementById("eventlist" + i + "" + i).classList.add("hideDiv");
        }
        document.getElementById("eventlist" + i + "" + i).classList.remove("hideArrow");
      }
    }
  }

  /** For redirecting to events calendar list view
   * @class BpgSiteHomePageComponent
   * @method viewMoreEvents
   */
  viewMoreEvents() {
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    var navigatePath = "naacHome";
    var idsAndNavigatePath = {
      'siteId': null,
      'naacAffinityId': this.naacAffinityId,
      'path': navigatePath
    }
    this.data.selectedSiteIdAndPath(idsAndNavigatePath);
    this.router.navigate(['events-list-view']);
  }

  /** For displaying complete description when 'view details' is clicked
   * @class BpgSiteHomePageComponent
   * @method viewMoreEventsDetails

   */
  viewMoreEventsDetails(event_id) {
    sessionStorage.setItem(this.iconKeyList, "SITELIST");
    for (var i = 0; i < this.upcoming_events_info.length; i++) {
      if (this.upcoming_events_info[i].eventId == event_id) {
        this.eventDetails = this.upcoming_events_info[i];
        Object.assign(this.eventDetails, { 'componentName': 'naacHomePage' });
        sessionStorage.setItem("eventDetails", JSON.stringify(this.eventDetails));
        this.router.navigate(['event-view-details']);
      }
    }
  }

}


